import enabledLanguageIds from './enabled-languages';

export const languages = {
    enabledLanguageIds
};